import EfImg from '@elem/ui/ef-img';
import React from 'react';
import classNames from 'classnames';
import styles from './index.module.scss';

interface SubItemProps {
    className?: string;
    title: string;
    imgs: {
        pc: string;
        pad?: string;
        h5?: string;
    };
    list: {
        count: string;
        text: string;
    }[];
}

const SubItem: React.FC<SubItemProps> = ({ className, title, list, imgs }) => {
    return (
        <div className={classNames(styles.TheComp, className)}>
            <EfImg className="ef-subitem-img" pc={imgs.pc} pad={imgs.pc} h5={imgs.h5} />
            <div className="ef-subitem-info">
                <p className="ef-subitem-info-title">{title}</p>
                <ul className="ef-subitem-info-items">
                    {list
                        ?.map((i) => ({ num: 1, background: 'linear-gradient(76deg, #3F68E0 17.14%, #7D9DFC 80.22%)', width: '100%', ...i }))
                        ?.map((i, k) => (
                            <li className="ef-subitem-info-item" key={k}>
                                <p className="bar"></p>
                                <p className="text">{i.text}</p>
                                <p className="count">{i.count}</p>
                            </li>
                        ))}
                </ul>
            </div>
        </div>
    );
};

export default SubItem;
